import { ButtonsComponent } from './buttons';
export const Buttons = ButtonsComponent;